
import { ResultsDTO } from "Types";
import {
  CheckPinCodeAvailability,
  CheckPinCodeAvailabilityRequest,
  CreateManifestationDTO,
  CreateShipmentRequestDTO,
  CancelManifestationDTO,
  CancelShipmentRequestDTO,
  TrackShipmentDataResponse,
  TrackShipmentRequest,
  RequestRefundResponse,
} from "Interface";





import { ApiService } from "./ApiService";
import { decodeParamList } from "Utilities/urlEncoder";

export const ShipmentApiSlice = ApiService.injectEndpoints({
    endpoints: (builder) => ({
        checkPinCodeAvailability: builder.query<CheckPinCodeAvailability, CheckPinCodeAvailabilityRequest>({
            query: ({ pinCode, productType }) => {
                let decodedProductType = productType;
                if (decodedProductType) {
                    decodedProductType = decodeParamList(decodedProductType).map(v => v.toUpperCase()).join(",");
                }
                return {
                    url: `/shipping/delhivery/check-pincode-availability?pinCode=${pinCode}&productType=${decodedProductType}`,
                    method: 'GET'
                };
            },
            transformResponse: (res: { results: CheckPinCodeAvailability }) => res.results,
        }),
        createForwardShipment: builder.mutation<CreateManifestationDTO, CreateShipmentRequestDTO>({
            query: (createShipmentRequestDTO) => ({
                url: '/shipment/create?shipment=forward',
                method: 'POST',
                body: { ...createShipmentRequestDTO }
            }),
            transformResponse: (res: ResultsDTO<CreateManifestationDTO>) => res.results,
        }),
        createReverseShipment: builder.mutation<CreateManifestationDTO, CreateShipmentRequestDTO>({
            query: (createShipmentRequestDTO) => ({
                url: '/shipment/create?shipment=reverse',
                method: 'POST',
                body: { ...createShipmentRequestDTO }
            }),
            transformResponse: (res: ResultsDTO<CreateManifestationDTO>) => res.results,
        }),
        cancelShipment: builder.query<CancelManifestationDTO, CancelShipmentRequestDTO>({
            query: (cancelManifestationDTO) => ({
                url: `/shipment/cancel?waybillNo=${cancelManifestationDTO.waybillNo}`,
                method: 'GET'
            }),
            transformResponse: (res: ResultsDTO<CancelManifestationDTO>) => res.results,
        }),
        trackOrder: builder.query<TrackShipmentDataResponse, TrackShipmentRequest>({
            query: (trackShipment) => ({
                url: `/shipping/delhivery/track-shipment?waybill=${trackShipment.waybill}&orderId=${trackShipment.orderId}`,
                method: 'GET'
            })
        }),
        requestRefundAllProducts: builder.query<RequestRefundResponse, { orderId: string }>({
            query: ({ orderId }) => ({
                url: `/shipment/request-refund?orderId=${orderId}&refundType=ALL`,
                method: 'GET'
            })
        }),
        requestRefundIndividualProduct: builder.query<RequestRefundResponse, { orderId: string, itemCode: string, waybillNo: string }>({
            query: ({ orderId, itemCode, waybillNo }) => ({
                url: `/shipment/request-refund?orderId=${orderId}&itemCode=${itemCode}&waybillNo=${waybillNo}&refundType=INDIVIDUAL`,
                method: 'GET'
            }),
            transformResponse: (res: ResultsDTO<RequestRefundResponse>) => res.results,
        })
    })
});

export const { useLazyCheckPinCodeAvailabilityQuery, useCreateForwardShipmentMutation, useCreateReverseShipmentMutation, useLazyCancelShipmentQuery, useLazyTrackOrderQuery, useLazyRequestRefundAllProductsQuery, useLazyRequestRefundIndividualProductQuery } = ShipmentApiSlice;
